import { render, staticRenderFns } from "./userDietTerms.vue?vue&type=template&id=8049d694&scoped=true"
import script from "./userDietTerms.vue?vue&type=script&lang=js"
export * from "./userDietTerms.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8049d694",
  null
  
)

export default component.exports